import { DragEvent, memo, useCallback, useState } from 'react';

import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { useStyles } from './DropZone.styles';
import { DropZoneProps } from './DropZone.types';

export const DropZone = memo(({ enabled, disabled, children, onFilesDropped }: DropZoneProps) => {
  const styles = useStyles();

  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback(
    (event: DragEvent<HTMLDivElement>) => {
      event.preventDefault();

      if (!disabled) {
        setIsDragging(true);
      }
    },
    [disabled],
  );

  const handleDragLeave = useCallback((event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (event: DragEvent<HTMLDivElement>) => {
      event.preventDefault();
      setIsDragging(false);

      if (disabled) {
        return;
      }

      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        onFilesDropped(event.dataTransfer.files);
      }
    },
    [disabled, onFilesDropped],
  );

  if (!enabled) {
    return children;
  }

  return (
    <div
      className={clsx(styles.dropZone, isDragging && styles.dropZoneActive, disabled && styles.dropZoneDisabled)}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <Typography variant="body2" className={styles.hint}>
        Drag & drop files here, or
      </Typography>

      {children}
    </div>
  );
});
